export default __webpack_public_path__ + "static/media/squares.45944236.svg";